import * as angular from "angular";
import * as later from "later";
import * as CronBuilder from "cron-builder";

class NewsletterDistributionService {
    items: any[];
    orderByOptions: string[];
    sortOrderOptions: string[];
    isSearchVisible: boolean;
    searchText: string;
    orderBy: string;
    sortOrder: string;
    paging: any;
    outputId: string;
    loadPagePromise: any;
    filteredItems: any[];
    newsletter: any;
    user: any;
    company: any;
    isRecurringNewsletter: boolean;
    isOneOffNewsletter: boolean;
    nextSchedule: string;
    isLoading: boolean;
    enableAnalytics: boolean;
    dynEntitlement: boolean;

    constructor(
        private OutputNewsletterService,
        private $q,
        private $routeParams,
        private OutputNewsletterDistributionService ,
        private OutputNewsletter,
        private CoreUserService,
        private CoreCompanyService,
        private OutputNewsletterDistribution,
        private moment,
        private $filter,
        private OutputConfig,
        private FAIRHAIR_WEB_URL,
        private EntitlementService,
        private ToggleFeature,
        private ToggleFeatureService
    ) {
        'ngInject';
        this.resetNLDDataTable();
        this.dynEntitlement = false;
        this.enableAnalytics = false;
    }

    getCurrentUser() {
        return this.CoreUserService
            .getCurrent(true)
            .then((user) => {
                this.user = user;
            });
    }

    getCurrentCompany() {
         return this.CoreCompanyService
            .getCurrent(true)
            .then((company) => {
                this.company = company;
                this.getNewsletterAnalyticsEnabled();
            })
    }

    /**
     * Fetches newsletter object by id.
     * @param newsletterId
     */
    getNewsletter(newsletterId) {
        let deferred = this.$q.defer();
        this.OutputNewsletterService
            .getNewsletterById(newsletterId)
            .then(
                (newsletter) => {
                    this.newsletter = newsletter;

                    if (
                        (
                            this.newsletter &&
                            this.newsletter.settings &&
                            this.newsletter.settings.recurring
                        ) &&
                        this.newsletter &&
                        this.newsletter.settings &&
                        this.newsletter.settings.schedules &&
                        Array.isArray(this.newsletter.settings.schedules)
                    ) {
                        this.nextSchedule = this.calculateSchedule(this.newsletter.settings)
                    }

                    deferred.resolve(newsletter);
                },
                (error) => {
                    if(error.status && error.status === 404) {
                        deferred.reject(new Error('newsletterNotFound'));
                    } else {
                        deferred.reject(error);
                    }
                }
            );

        return deferred.promise;
    }

    /**
     * Fetches all distributions for this newsletter
     * @param newsletterId
     */
    getNewsletterDistributions(newsletterId) {
        let deferred = this.$q.defer();
        this.OutputNewsletterDistributionService
            .getOutputNewsletterDistributions(newsletterId)
            .then(
                (items) => {
                    this.items = items;
                    deferred.resolve(items);
                },
                (error) => {
                    deferred.reject(error);
                }
            );

        return deferred.promise;
    }

    getDynEntitlement(){
        let deferred = this.$q.defer();

        this.EntitlementService.getCompanyEntitlement('dyn-newsletter-entitlement')
            .then((entitlement)=>{
                this.dynEntitlement = entitlement['dyn-newsletter-entitlement'] ? entitlement['dyn-newsletter-entitlement'].value : false;
                deferred.resolve();
            })
            .catch(error =>{
                this.dynEntitlement = false;
                deferred.resolve();
            })

        return deferred.promise;
    }

    getNewsletterAnalyticsEnabled() {
        this.ToggleFeature.user={
            key: this.company._id
        };

        var me = this;
        this.ToggleFeatureService.getTreatment('NEWSLETTER_ANALYTICS')
            .then(function(treatment){
                me.enableAnalytics = treatment.toString()==="on" ? true : false;
            })
            .catch(error => {
                me.enableAnalytics = false;
            })
    }
    /**
     * loads a designated page of newsletter distribution data
     */
    load() {
        let promiseArray = [
            this.getCurrentUser(),
            this.getCurrentCompany(),
            this.getNewsletter(this.$routeParams.outputId),
            this.getNewsletterDistributions(this.$routeParams.outputId),
            this.getDynEntitlement()
        ],
        deferred = this.$q.defer();

        this.$q.all(promiseArray)
            .then(() => {
                this.newsletter = this.OutputNewsletter.build(this.newsletter, this.company, this.user);
                this.items = this.OutputNewsletterDistribution.build(this.items, this.company, this.user);
                this.isRecurringNewsletter = (this.newsletter && this.newsletter.settings && this.newsletter.settings.recurring);
                this.isOneOffNewsletter = (this.newsletter && this.newsletter.settings && this.newsletter.settings.oneOff);
                angular.forEach(this.items, (distributions, key) => {
                    // Get the status of the distribution
                    this.items[key].displayStatus = this.OutputNewsletterDistributionService.getOutputNewsletterDistributionDisplayStatus(this.items[key]);
                });
                this.filteredItems = this.items;
                // Handle Successful Response
                this.paging.selectedPage = 1;
                this.paging.totalItems = this.items.length;
                this.outputId = this.$routeParams.outputId;

                deferred.resolve('done');
            })
            .catch((error) => {
                deferred.reject(error);
            })
            .finally(() => {
                this.isLoading = false;
            });

        this.loadPagePromise = deferred.promise;

        return this.loadPagePromise;
    }

    /**
     * Reset the state
     */
    resetNLDDataTable() {
        this.newsletter = {};
        this.user = {};
        this.company = {};
        this.items = [];
        this.filteredItems = [];
        this.orderByOptions = [
            'mw-newsletter-distribution-data-table__table-header--instance',
            'mw-newsletter-distribution-data-table__table-header--subject',
            'mw-newsletter-distribution-data-table__table-header--status',
            'mw-newsletter-distribution-data-table__table-header--schedule'
        ];
        this.sortOrderOptions = [
            'Ascending',
            'Descending'
        ];
        this.isSearchVisible = false;
        this.searchText = '';
        this.orderBy = 'nextInstanceId';
        this.sortOrder = 'DESC';
        this.paging = {
            itemsPerPage: 25,
            selectedPage: 1,
            totalItems: 0
        };
        this.isRecurringNewsletter = true;
        this.isOneOffNewsletter = false;
        this.nextSchedule = '';
        this.isLoading = true;
    }

    /**
     *
     * @param searchText
     * @return {any}
     */
    filterNewsletterDistributions(searchText) {
        let items = this.items;
        if(searchText && items) {
            this.filteredItems = items.filter((item) => {
                return (
                    (item.nextInstanceId && JSON.stringify(item.nextInstanceId).indexOf(searchText) != -1)
                    ||
                    (item.newsletterSubject && item.newsletterSubject.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                    ||
                    (item.displayStatus && item.displayStatus.toLowerCase().indexOf(searchText.toLowerCase()) != -1)
                );
            });
        } else {
            this.filteredItems = items;
        }
        this.updatePaging();
    }

    /**
     * Updates the paging data to match the current filtered item set
     */
    updatePaging(){
        this.paging.selectedPage = 1;
        this.paging.totalItems = this.filteredItems.length;
    }

    deleteDistributions(selectedDistributionIds) {
        return this.OutputNewsletterDistributionService
            .deleteOutputNewsletterDistributions(this.newsletter._id, selectedDistributionIds)
            .then(() => {
                this.load();
            });
    }

    calculateSchedule(settings) {
        var schedule,
            currentDate,
            cronBuilder = new CronBuilder(),
            time,
            daysArray = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            daysToNumbersArray = [],
            scheduleDate,
            laterSchedule,
            laterNextRun,
            nextRunDateTime;

        if (
           !settings.nextRunDate && Array.isArray(settings.schedules)
        ) {
            //since we have only 1 schedule, just take the 1st one.
            schedule = settings.schedules[0];

            time = schedule.time.split(':');
            currentDate = this.moment.tz(schedule.timezone).utc();

            schedule.days.forEach(function (day) {
                if (daysArray.indexOf(day) >= 0) {
                    daysToNumbersArray.push('' + ((daysArray.indexOf(day) + 1) === 7 ? 0 : (daysArray.indexOf(day) + 1)));
                }
            });

            cronBuilder.set('minute', time.slice(1));
            cronBuilder.set('hour', time.slice(0, 1));
            cronBuilder.set('dayOfTheWeek', daysToNumbersArray);
            later.date.localTime();
            laterSchedule = later.parse.cron(cronBuilder.build());

            laterNextRun = this.moment.utc(later.schedule(laterSchedule).next(1, currentDate));

            nextRunDateTime = this.moment.tz(schedule.timezone);
            nextRunDateTime.set('year', laterNextRun.year());
            nextRunDateTime.set('month', laterNextRun.month());
            nextRunDateTime.set('date', laterNextRun.date());
            nextRunDateTime.set('hour', laterNextRun.hour());
            nextRunDateTime.set('minute', laterNextRun.minute());
            nextRunDateTime.set('second', 0);

            scheduleDate = this.$filter('mwConvertDateToUserTimezone')(laterNextRun.utc().toISOString(), this.OutputConfig.OUTPUT_DATE_FORMAT);
        } else {
            scheduleDate =  this.$filter('mwConvertDateToUserTimezone')(settings.nextRunDate, this.OutputConfig.OUTPUT_DATE_FORMAT);
        }

        return scheduleDate;
    }

    /**
     * Get a distribution
     * @param distributionId
     * @returns {any}
     */
    getNewsletterDistribution(distributionId) {
        return this.OutputNewsletterDistributionService.getOutputNewsletterDistribution(null, distributionId);
    }

    /**
     * Gets HTML content of distribution
     * @param distributionId
     * @returns {any}
     */
    getNewsletterDistributionHTML(url) {
        return this.OutputNewsletterDistributionService.getNewsletterDistributionHTML(url);
    }

    /**
     * Duplicates a Newsletter Distribution
     * @param distributionId
     * @param recipientListId
     * @param subjectLine
     * @returns {any}
     */
    duplicateNewsletterDistribution(distributionId, recipientListId, subjectLine) {
        return this.OutputNewsletterDistributionService.duplicateNewsletterDistribution(distributionId, recipientListId, subjectLine);
    }

    copyDistributionDataToDraft(distribution, newsletter) {
       return this.getNewsletterDistribution(distribution._id)
            .then((distributionData) => {
                distributionData.schedulingOption = 'SAVE_DRAFT';
                distributionData.created = null;
                distributionData.modified = null;
                distributionData.scheduledDate = null;
                distributionData.nextInstanceId = newsletter.nextInstanceId;
                this.OutputNewsletterDistributionService.createOutputNewsletterDistribution(null, distributionData)
                    .then(() => {
                        this.load();
                    });
            })
    }


}

export default NewsletterDistributionService;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distributions-state.service.ts
 **/